import React, { Component } from 'react';
import firebase from '../helper/firebase';

import { Link } from 'react-router-dom';

import {
	Button,
	Card,
	Checkbox,
	Divider,
	Hidden,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableHead,
	TableRow,
	TableCell,
	TextField,
	Toolbar,
	Typography
} from 'material-ui';
import Tabs, { Tab } from 'material-ui/Tabs';

import Dialog, {
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from 'material-ui/Dialog';

import EmptyState from '../components/EmptyState';

import Fade from 'material-ui/transitions/Fade';

import ChevronLeftIcon from 'material-ui-icons/ChevronLeft';
import ChevronRightIcon from 'material-ui-icons/ChevronRight';
import StarIcon from 'material-ui-icons/Star';
import StarBorderIcon from 'material-ui-icons/StarBorder';

const style = {
	selectedToolbar: {
		color: '#c51162',
		backgroundColor: '#ff80ab'
	},
	toolbarTitle: {
		flex: '0 0 auto'
	},
	toolbarTitleName: {
		textTransform: 'capitalize'
	},
	toolbarSpacer: {
		flex: '1 1 100%'
	},
	actionButtons: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	actionInstructions: {
		marginRight: '5px'
	}
};

export default class ApplicantTabs extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selection: {},
			applicants: this.props.applicants,
			selectedUsers: [],
			jid: this.props.jid,
			selectionLoading: true,
			stages: this.props.stages,
			value: this.props.stages[1],
			candidateAbout: ''
		};
	}

	componentWillUnmount() {
		const ref = firebase.database().ref();
		ref.child(`selection/${this.state.jid}`).off();
	}

	componentDidMount() {
		this.getInfo();
		this.setMaxStage();
	}

	setMaxStage = () => {
		const { stages, jid } = this.state;
		firebase
			.database()
			.ref(`selection/${jid}`)
			.once('value')
			.then(snap => {
				if (snap.val() !== null) {
					const maxStage = Math.max.apply(Math, Object.values(snap.val()));
					this.setState({
						value: stages[maxStage]
					});
				}
			});
	};

	getInfo = () => {
		const ref = firebase.database().ref();
		ref.child(`selection/${this.state.jid}`).on('value', snap => {
			if (snap.val() !== null) {
				this.setState({
					selection: snap.val(),
					selectionLoading: false
				});
			} else {
				this.setState({
					selection: [],
					selectionLoading: false
				});
			}
		});
	};

	handleChange = (event, value) => {
		this.setState({ value, selectedUsers: [] });
	};

	handleAboutCandidateChange = e =>
		this.setState({ candidateAbout: e.target.value });

	isSelected = id => this.state.selectedUsers.indexOf(id) !== -1;

	handleTableRowClick = (e, id) => {
		let { selectedUsers, value, stages } = this.state;
		if (
			stages.indexOf(value) + 1 >= stages.length - 1 ||
			stages.indexOf(value) === 0 ||
			stages.indexOf(value) === 1
		) {
			this.isSelected(id)
				? selectedUsers.splice(selectedUsers.indexOf(id), 1)
				: (selectedUsers = [id]);
			this.setState({ selectedUsers });
		} else {
			this.isSelected(id)
				? selectedUsers.splice(selectedUsers.indexOf(id), 1)
				: selectedUsers.push(id);
			this.setState({ selectedUsers });
		}
		this.setState({ advancing: true, regressing: true });
	};

	renderApplicantsTable = () => {
		const { applicants } = this.props;
		const { value, selection, stages } = this.state;
		let html = [];
		if (Object.keys(applicants).length === 0) {
			let card = (
				<EmptyState
					key="no applicants"
					subject={'No Applicants'}
					message={'Share your Ad to receiving applicants.'}
					btnDestination={'/MyJobs'}
					btnMsg={'Back to My Jobs'}
				/>
			);
			html.push(card);
			return html;
		}
		for (let applicant in applicants) {
			if (
				(stages.indexOf(value) === 1 &&
					selection[applicants[applicant].uid] === undefined) ||
				selection[applicants[applicant].uid] === stages.indexOf(value)
			) {
				const isSelected = this.isSelected(applicants[applicant].uid);
				let newTimestamp = new Date(applicants[applicant].timestamp);
				let newDate = `${newTimestamp.getDate()}/${newTimestamp.getMonth() +
					1}/${newTimestamp.getFullYear()}`;
				let row = (
					<TableRow
						hover={this.props.job.status !== 'hired'}
						onClick={
							this.props.job.status !== 'hired'
								? event =>
										this.handleTableRowClick(event, applicants[applicant].uid)
								: null
						}
						role={this.props.job.status !== 'hired' ? 'checkbox' : null}
						aria-checked={isSelected}
						tabIndex="-1"
						selected={isSelected || this.props.job.status === 'hired'}
						key={applicants[applicant].uid}
					>
						{this.props.job.status !== 'hired' ? (
							<TableCell padding="checkbox">
								<Checkbox checked={isSelected} />
							</TableCell>
						) : (
							<TableCell />
						)}
						<TableCell>{applicants[applicant].displayName}</TableCell>
						<Hidden xsDown>
							<TableCell>
								{stages[selection[applicants[applicant].uid]] === undefined
									? 'Screening'
									: stages[selection[applicants[applicant].uid]]}
							</TableCell>
						</Hidden>
						<Hidden smDown>
							<TableCell>{newDate}</TableCell>
						</Hidden>
						<TableCell>
							<Link
								to={`/Applicant/${applicants[applicant].jid}/${
									applicants[applicant].uid
								}`}
							>
								<Button dense color="primary">
									View
								</Button>
							</Link>
						</TableCell>
					</TableRow>
				);
				html.push(row);
			}
		}
		return html;
	};

	advanceApplicant = () => {
		let { selectedUsers, jid, stages, value, selection } = this.state;
		let ref = firebase.database().ref();
		// if(stages.indexOf(value)+1===stages.length-1){
		//   this.setState({
		//     dialogOpen:true,
		//     dialogTitle:`Hire ${applicants[selectedUsers[0]].displayName}?`,
		//     dialogContent:`Please confirm that you would like to hire ${applicants[selectedUsers[0]].displayName}. If you select agree, the candidates and referees will be notified and this job will be marked as closed and hired. This action cannot be undone.`
		//   })
		//   return;
		// }
		let selectionUpdate = {};
		let counter = 0;
		for (let user in selectedUsers) {
			let usersStage = selection[selectedUsers[user]];
			console.log(usersStage);
			if (usersStage === 1 || !usersStage) {
				this.setState({
					dialogOpen: true,
					feedbackSelectionState: 'Interviewing',
					advancing: true,
					regressing: false
				});
			} else {
				let usersStage = selection[selectedUsers[user]];
				usersStage === undefined ? (usersStage = 2) : usersStage++;
				if (usersStage >= stages.length) {
					usersStage--;
				}
				selectionUpdate[selectedUsers[user]] = usersStage;
				counter++;
				if (counter >= selectedUsers.length) {
					ref
						.child(`selection/${jid}`)
						.update(selectionUpdate)
						.then(() => {
							this.setState({
								value:
									stages.indexOf(value) === stages.length - 1
										? stages[stages.length - 1]
										: stages[stages.indexOf(value) + 1]
							});
							if (stages.indexOf(value) + 1 === stages.length - 1) {
								this.setState({
									selectedUsers: []
								});
							}
						})
						.catch(err => {
							console.log(err);
						});
				}
			}
		}
	};

	regressApplicant = () => {
		let { selectedUsers, jid, stages, value, selection } = this.state;
		let ref = firebase.database().ref();
		let selectionUpdate = {};
		let counter = 0;
		for (let user in selectedUsers) {
			let usersStage = selection[selectedUsers[user]];
			console.log(usersStage);
			if (usersStage === 1 || !usersStage) {
				this.setState({
					dialogOpen: true,
					feedbackSelectionState: 'Not Appropriate',
					regressing: true,
					advancing: false
				});
			} else {
				usersStage === undefined ? (usersStage = 0) : usersStage--;
				if (usersStage < 0) {
					usersStage = 0;
				}
				selectionUpdate[selectedUsers[user]] = usersStage;
				counter++;
				if (counter === selectedUsers.length) {
					ref
						.child(`selection/${jid}`)
						.update(selectionUpdate)
						.then(() => {
							this.setState({
								value:
									stages.indexOf(value) > 0
										? stages[stages.indexOf(value) - 1]
										: stages[0]
							});
							if (stages.indexOf(value) + 1 === stages.length - 1) {
								this.setState({
									selectedUsers: []
								});
							}
						})
						.catch(err => {
							console.log(err);
						});
				}
			}
		}
	};

	handleDialogClose = () => this.setState({ dialogOpen: false });

	handleMarkNotAppropriate = () => {
		let { selectedUsers, jid, stages } = this.state;
		let ref = firebase.database().ref();
		let promises = [];
		let endorsementUpdate = {
			about: this.state.candidateAbout,
			endorser: this.props.uid,
			rating: this.state.rating,
			employer: true,
			timestamp: Date.now()
		};
		promises.push(
			ref.child(`selection/${jid}/`).update({ [`${selectedUsers[0]}`]: 0 }),
			ref
				.child(`endorsements/${selectedUsers[0]}/${jid}/${this.props.uid}`)
				.update(endorsementUpdate)
		);
		Promise.all(promises)
			.then(() => {
				this.setState({
					value: stages[0],
					selectedUsers: [],
					dialogOpen: false,
					rating: 0,
					candidateAbout: ''
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	handleMarkInterviewing = () => {
		let { selectedUsers, jid, stages } = this.state;
		let ref = firebase.database().ref();
		let promises = [];
		let endorsementUpdate = {
			about: this.state.candidateAbout,
			endorser: this.props.uid,
			rating: this.state.rating,
			employer: true,
			timestamp: Date.now()
		};
		promises.push(
			ref.child(`selection/${jid}/`).update({ [`${selectedUsers[0]}`]: 2 }),
			ref
				.child(`endorsements/${selectedUsers[0]}/${jid}/${this.props.uid}`)
				.update(endorsementUpdate)
		);
		Promise.all(promises)
			.then(() => {
				this.setState({
					value: stages[2],
					selectedUsers: [],
					dialogOpen: false,
					rating: 0,
					candidateAbout: ''
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	render() {
		return (
			!this.state.selectionLoading && (
				<React.Fragment>
					<Fade in={!this.state.loading}>
						<Card className="card">
							<Paper className="applicantsTabToolbarPaper" elevation={0}>
								<Toolbar
									className="applicantsTabToolbar"
									style={
										this.state.selectedUsers.length > 0
											? style.selectedToolbar
											: null
									}
								>
									<div style={style.toolbarTitle}>
										{this.state.selectionLoading || this.state.stagesLoading ? (
											<Typography style={style.toolbarTitleName} type="title">
												Applicants Loading...
											</Typography>
										) : this.state.selectedUsers.length > 0 ? (
											<Typography type="subheading">{`${
												this.state.selectedUsers.length
											} user${
												this.state.selectedUsers > 1 ? 's' : ''
											} selected.`}</Typography>
										) : (
											<Typography style={style.toolbarTitleName} type="title">
												{this.state.value}
											</Typography>
										)}
									</div>
									<div style={style.toolbarSpacer} />
									{this.state.selectedUsers.length > 0 &&
									this.props.job.status !== 'hired' ? (
										<div style={style.actionButtons} className="actionButtons">
											<Typography style={style.actionInstructions}>
												Move:
											</Typography>
											<Button
												onClick={this.regressApplicant}
												dense
												aria-label="Navigate Previous"
											>
												<ChevronLeftIcon />
											</Button>
											{this.state.stages.indexOf(this.state.value) + 1 ===
											this.state.stages.length - 1 ? (
												<Link
													to={`/Hire/${this.state.jid}/${
														this.state.selectedUsers[0]
													}`}
												>
													<Button disableRipple>
														<Typography>HIRE</Typography>
													</Button>
												</Link>
											) : (
												<Button
													disableRipple
													raised={false}
													onClick={this.advanceApplicant}
													dense
													aria-label="Navigate Next"
												>
													<ChevronRightIcon />
												</Button>
											)}
										</div>
									) : null}
								</Toolbar>
								<Tabs
									fullWidth
									centered
									value={this.state.value}
									onChange={this.handleChange}
									indicatorColor="primary"
									textColor="primary"
									scrollable
									scrollButtons="auto"
								>
									{this.state.stages.map(stage => {
										return <Tab key={stage} value={stage} label={stage} />;
									})}
								</Tabs>
							</Paper>
							<Divider light />
							<Table>
								<TableHead>
									<TableRow>
										<TableCell padding="none" />
										<TableCell>Name</TableCell>
										<Hidden xsDown>
											<TableCell>Stage</TableCell>
										</Hidden>
										<Hidden smDown>
											<TableCell>Date</TableCell>
										</Hidden>
										<TableCell>Application</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{this.state.selectionLoading || this.state.stagesLoading
										? null
										: this.renderApplicantsTable()}
								</TableBody>
							</Table>
						</Card>
					</Fade>
					<Dialog open={this.state.dialogOpen} onClose={this.handleDialogClose}>
						<DialogTitle id="reject-applicant-title">
							{!!this.state.selectedUsers[0]
								? this.state.applicants[this.state.selectedUsers[0]].displayName
								: 'Candidate'}{' '}
							{this.state.feedbackSelectionState}
						</DialogTitle>
						<DialogContent>
							<DialogContentText>
								To label{' '}
								{!!this.state.selectedUsers[0]
									? this.state.applicants[this.state.selectedUsers[0]]
											.displayName
									: 'this candidate'}{' '}
								as {this.state.feedbackSelectionState}, please tell us a bit
								about why that is the case. This will help us improve our
								ability to surface the best candidates for you.
							</DialogContentText>
							<div style={style.rating} className="rating">
								<IconButton
									onClick={() => {
										this.setState({ rating: 1 });
									}}
									aria-label="Rating: 1"
								>
									{this.state.rating > 0 ? (
										<StarIcon style={style.star} />
									) : (
										<StarBorderIcon style={style.star} />
									)}
								</IconButton>
								<IconButton
									onClick={() => {
										this.setState({ rating: 2 });
									}}
									aria-label="Rating: 2"
								>
									{this.state.rating > 1 ? (
										<StarIcon style={style.star} />
									) : (
										<StarBorderIcon style={style.star} />
									)}
								</IconButton>
								<IconButton
									onClick={() => {
										this.setState({ rating: 3 });
									}}
									aria-label="Rating: 3"
								>
									{this.state.rating > 2 ? (
										<StarIcon style={style.star} />
									) : (
										<StarBorderIcon style={style.star} />
									)}
								</IconButton>
								<IconButton
									onClick={() => {
										this.setState({ rating: 4 });
									}}
									aria-label="Rating: 4"
								>
									{this.state.rating > 3 ? (
										<StarIcon style={style.star} />
									) : (
										<StarBorderIcon style={style.star} />
									)}
								</IconButton>
								<IconButton
									onClick={() => {
										this.setState({ rating: 5 });
									}}
									aria-label="Rating: 5"
								>
									{this.state.rating > 4 ? (
										<StarIcon style={style.star} />
									) : (
										<StarBorderIcon style={style.star} />
									)}
								</IconButton>
							</div>
							<TextField
								fullWidth
								type="text"
								id="candidateAbout"
								label="About Candidate"
								placeholder="About candidate..."
								margin="normal"
								multiline
								onChange={this.handleAboutCandidateChange}
								value={this.state.candidateAbout}
								style={style.aboutInput}
							/>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleDialogClose} color="primary">
								Cancel
							</Button>
							<Button
								onClick={
									this.state.regressing
										? this.handleMarkNotAppropriate
										: this.state.advancing ? this.handleMarkInterviewing : null
								}
								color="primary"
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</React.Fragment>
			)
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ApplicantTabs.js